import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export default function MyAppBar({
  handleRightMenu,
  arrowBackEnable,
  handleBack,
}) {
  return (
    <Box sx={{ flexGrow: 1, backgroundColor: "#2e2b2d" }}>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "#2e2b2d", color: "#fff5ff" }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleRightMenu}
          >
            <MenuIcon />
          </IconButton>
          {
            <Typography variant="subtitle1" component="p" sx={{ flexGrow: 1 }}>
              Hamrah Negin
            </Typography>
          }
          {arrowBackEnable && <ArrowBackIosNewIcon onClick={handleBack} />}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
